export { JobTitleFieldModule } from './job-title-field.module';
export { JobTitleFieldSize } from './types';
